import type { FC } from "react"
import type { PopoverProps } from "antd"
import { Flex, Popover } from "antd"
import { WECHAT_GROUP_QRCODE_URL } from "~/common/links"
import { Text } from "~/components/Text"
import styles from "./CommunityPopover.css"

const BENEFITS = [
  { badge: "爆", label: "爆款案例与提示词" },
  { badge: "技", label: "视频生成实用技巧" },
  { badge: "新", label: "新功能优先体验" },
  { badge: "答", label: "创作交流与官方答疑" },
] as const

// 侧边栏「加入微信群」点击后弹出的社群卡片
export const CommunityPopover: FC<PopoverProps> = (props) => (
  <Popover
    arrow={false}
    classNames={{ container: styles.container }}
    content={<CommunityCard />}
    placement="rightBottom"
    trigger="click"
    {...props}
  />
)

const CommunityCard = () => (
  <Flex
    className={styles.card}
    vertical
  >
    <Flex
      className={styles.header}
      vertical
      gap={6}
    >
      <Text
        size={20}
        strong
      >
        咔嗒爆创作交流群
      </Text>
      <Text type="secondary">扫码进群，交流 AI 带货视频创作玩法</Text>
    </Flex>
    <Flex
      className={styles.body}
      vertical
      gap={20}
    >
      <Flex
        align="center"
        gap={20}
      >
        <span className={styles.qrcode}>
          <img
            alt="咔嗒爆创作交流群二维码"
            src={WECHAT_GROUP_QRCODE_URL}
          />
        </span>
        <Flex
          vertical
          gap={6}
          align="flex-start"
        >
          <Text
            strong
            size="l"
          >
            微信扫码加入
          </Text>
          <Text
            type="secondary"
            size="s"
          >
            获取实战玩法与官方答疑
          </Text>
          <Text className={styles.scanTag}>打开微信扫一扫</Text>
        </Flex>
      </Flex>
      <div className={styles.benefits}>
        {BENEFITS.map(({ badge, label }) => (
          <Flex
            key={label}
            align="center"
            gap={8}
          >
            <span
              className={styles.benefitBadge}
              aria-hidden
            >
              {badge}
            </span>
            <Text size="s">{label}</Text>
          </Flex>
        ))}
      </div>
    </Flex>
  </Flex>
)
